export class GlobalConstants {
  /* LMS-2445 - status constants */
  public static connected = "On-Line"; //  Connected
  public static lost = "Lost"; // Offline;
  public static offline = "Off-Line"; // Missing
  public static notConnected = "Provisioned"; //  Not Connected
  public static latest = "latest"; //to retrive latest rule
  public static productGroup = [
    "danaherdigital.com",
    "leica-microsystems.com",
    "jenoptik.com",
  ];
  public static whitelistDomainsRegExp = [
    { key: "aws", regExp: new RegExp("^(.*).amazonaws.com$") },
  ];

  public static physicalDeviceModelColDef = {
    field: "physicalDeviceModel",
    header: "Model",
    type: "text",
    enableSort: true,
  };

  public static serialNumberColDef = {
    field: "serialNumber",
    header: "Serial Number",
    type: "link",
    enableSort: true,
  };

  public static serviceRegionColDef = {
    field: "serviceRegion",
    header: "Service Region",
    type: "text",
    enableSort: true,
    colWidth: "13%",
  };

  public static productGroupColDef = {
    field: "productGroup",
    header: "Product Group",
    type: "text",
    enableSort: true,
    colWidth: "13%",
  };

  public static customerColDef = {
    field: "customer",
    header: "Customer",
    type: "text",
    enableSort: true,
    colWidth: "13%",
  };

  public static deleteColDef = {
    field: "deleteAction",
    header: "",
    type: "link-number",
    enableSort: false,
  };
  public static readonly ZERO: number = 25;
  public static readonly RED: string = "Red";
  public static readonly PURPLE: string = "Purple";
  public static readonly YELLOW: string = "Yellow";

  public static readonly ALL: string = "all";
  public static readonly WLL_ERROR: string = "error1";
  public static readonly ALL_ERROR: string = "error2";
  public static readonly WARNING: string = "warning";
  public static readonly OFFLINE: string = "offline";
  public static readonly LOST: string = "lost";
  public static readonly WATCHLIST: string = "watchlist";
  public static readonly DASHBOARDFILTER: string = "dashboardFilters";

  public static readonly DEFAULT_PAGE_SIZE: number = 25;
  public static readonly SORTING_FILTER: string = "saveSortingForFilter";
  public static readonly PROVISIONED: string = "PROVISIONED";
  public static readonly PROVISIONED_UI: string = "Provisioned";
  public static readonly MULTI_REGION_SEPERATOR: string = "::";
  public static readonly USER_TYPE_ID_CONDITION: string = "user";
  public static readonly USER_RELATION_ACCESS: string = "accessBy";
  public static readonly ERROR_LOWERCASE: string = "error";
  public static readonly SEPARATOR: string = "/";
  public static readonly SERVICE_REGION: string = "ServiceRegion";
  public static readonly ADMINISTRATOR: string = "Administrator";
  public static readonly ADMIN: string = "rc_Administrator";
  public static readonly STANDARD: string = "rc_Standard User";
  public static readonly LIMITED: string = "rc_Limited User";
  public static readonly DEV_ADMIN: string = "DevAdmin";
  public static readonly PRODUCT_GROUP: string = "ProductGroup";
  public static readonly TOKEN: string = "token";
  public static readonly REDIRECT_URL: string = "redirectUrl";
  public static readonly ASSIGNED_OU_LIST: string = "assignedOUList";
  public static readonly LMS_CONFIG: string = "lmsConfig";
  public static readonly REFRESH_TIME: string = "refreshTime";
  public static readonly LOGIN_TIME: string = "logInTime";
  public static readonly REFRESH_TIME_VALUE: number = 2700000;
  public static readonly DEVICE_DETAILS: string = "deviceDetails";
  public static readonly RULE_DETAILS: string = "rulesDetails";
  public static readonly SUCCESS: string = "SUCCESS";
  public static readonly ERROR: string = "ERROR";
  public static readonly FAILURE: string = "FAILURE";
  public static readonly TOAST_SUCCESS: string = "success";
  public static readonly TOAST_ERROR: string = "error";
  public static readonly STATUS: string = "status";
  public static readonly VALID: string = "VALID";
  public static readonly EXTERNAL: string = "EXTERNAL";
  public static readonly NATIVE: string = "NATIVE";
  public static readonly ROLE_NAME_INITIAL: string = "rc_";
  public static readonly UNDERSCORE: string = "_";
  public static readonly ROLE: string = "role";
  public static readonly REMOVE_SERVICE_REGION = "Remove Service Region";
  public static readonly USER_UPDATE_FAILED_SUMMARY: string =
    "User updation failed";
  public static readonly USER_DELETE_FAILED: string = "User Deletion Failed";
  public static readonly USER_DELETE_FAILED_SUMMARY: string =
    "User Deletion Failed";
  public static readonly USER_REMOVAL_FAILED: string = "User Removal Failed";
  public static readonly USER_REMOVAL_SUCCESS: string =
    "User Removed Successfully";
  public static readonly USER_REMOVAL_SUMMARY: string =
    "User Removed Successfully from Service Region";
  public static readonly USER_DELETE_ORPHAN_SUMMARY: string =
    "User Can't be removed from all Regions, If you still wants to then, delete the user completely";
  public static readonly USER_DELETE_COMMON_SUMMARY: string =
    "Something went wrong while deleting users.";
  public static readonly USER_NOT_AUTHORIZED: string =
    "User not Authorized to access device-details";
  public static readonly USER_CREATION_FAILED_SUMMARY: string =
    "User Creation Failed";
  public static readonly USER_CREATION_FAILED_MESSAGE: string =
    "Something went wrong while creating users, please check if user already exist";
  public static readonly USER_UPDATED_SUCCESS_SUMMARY: string =
    "User updated successfully";
  public static readonly USER_CREATION_SUCCESS_SUMMARY: string =
    "User Created Successfully";
  public static readonly USER_CREATION_ROLE_FAILED_MESSAGE: string =
    "Role is not selected.";
  public static readonly USER_CREATION_OU_FAILED_MESSAGE: string =
    "Please select valid Org groups";
  public static readonly USER_CREATION_SERVICE_REGION_FAILED_MESSAGE: string =
    "Selected service region is no longer available";
  public static readonly USER_GLOBAL_MESSAGE: string =
    "Administrator will have access to all the Service Regions as a LMS Parent User";

  public static readonly USER_MANDATORY_FIELD: string =
    "Please fill all mandatory fields";

    public static readonly RULE_GROUP_ID: string =
    "cebb16d8-a6e6-a7f0-361a-706197cd4ca2";

  public static readonly TOKEN_EXPIRE_ERROR_CODE: string = 'UM508';


}
